import axios from "axios";
import Modal from "component/Common/LoaderModal";
import { getUserToken, deviceInfo } from "helpers";
import { apiMethods, axiosErrorHandler, responseHandler, baseUrl, openUrl } from "./endpoints";

export const request = ({
  url,
  method = apiMethods.GET,
  data,
  isLoader = true,
  responseType,
  token = getUserToken(),
  params = null,
  showToast = false,
  signal,
  location = null,
  isCustomLoader,
  cancelToken,
  isNotOpen = true,
}) =>
  new Promise((resolve, reject) => {
    let config = {
      url: (isNotOpen ? baseUrl : openUrl) + url,
      method: method,
      params: params ? params : null,
      data: data ? data : null,
      cancelToken,
      responseType: responseType ? responseType : null,
      location: location,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
        "App-Type": deviceInfo(),
      },
      ...(signal
        ? {
            signal: signal,
          }
        : {}),
    };
    config.params == null && delete config.params;
    config.data == null && delete config.data;
    config.responseType == null && delete config.responseType;
    showLoader(isLoader);
    axios(config)
      .then((response) => {
        !isCustomLoader && showLoader(false);
        return resolve(responseHandler(response, showToast, showLoader), method);
      })
      .catch((error) => {
        showLoader(false);
        if (location) {
          let redirectPath = location?.pathname;
          if (location?.search) redirectPath += location?.search;
          return reject(axiosErrorHandler(error, showToast, redirectPath));
        }
        return reject(axiosErrorHandler(error, showToast));
      });
  });

const showLoader = (status) => {
  if (Modal && Modal.render && Modal.render.defaultProps) {
    Modal.render.defaultProps.setLoaderStatus(status);
  }
};
